import Home from './Home'
import Auth from './Auth'
import Dashboard from './Dashboard'

export default {
  Home,
  Auth,
  Dashboard
}



// WEBPACK FOOTER //
// ./src/navigators/index.js